// import './modules/shared/polyfill';
// import "babel-polyfill";
import {UtilService} from "./modules/shared/util.service";
import {InlinePaymentEngineModule} from './modules/inline-payment-engine/inline-payment-engine.module';

declare let window: any;

const RmPaymentEngine = new InlinePaymentEngineModule();
window.RmPaymentEngine = RmPaymentEngine;

UtilService.log("[index.ts]", 'RmPaymentEngine', (window as any) ['RmPaymentEngine']);



// WEBPACK FOOTER //
// ../inline/src/index.ts